<template>
  <div class="py-3">
    <div class="bg-white">
      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Solicitud de Transferencia
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Fecha de Solicitud de Transferencia:
              </p>
              <p class="font-16">
                {{ trasnferInfo?.requestDate | date }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Número de Solicitud:
              </p>
              <p class="font-16">
                {{ trasnferInfo?.requestCode | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Sometido Por:
              </p>
              <p class="font-16">
                {{ trasnferInfo?.user?.name | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Estatus:
              </p>
              <custom-balloon
                dot
                class="mt-2"
                :background-color="trasnferInfo.statusColor"
                :text="trasnferInfo.statusName"
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Razón:
              </p>
              <p class="font-16">
                {{ trasnferInfo?.reason | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inventoryTransferService from "@/services/api/inventoryTransfer.api";
import CustomBalloon from "custom-balloon";

export default {
  name: "TransferInfo",
  props: {
    transferId: {
      type: Number
    }
  },
  components: {
    CustomBalloon
  },
  data() {
    return {
      trasnferInfo: {}
    };
  },
  mounted() {
    this.getTransferDetails();
  },
  methods: {
    async getTransferDetails() {
      const { data } = await inventoryTransferService.get(this.transferId);
      this.trasnferInfo = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
</style>
